export const BUTTONS = {
    SAVE:1,
    PRINT:2,
    UPDATE:4,
    SAVE_AND_PRINT:8,
    UPDATE_AND_PRINT:16
}

export const EMPLOYEES=['Okhan', 'Johannes', 'Milos', 'Axel', 'Mats']
